export default __webpack_public_path__ + "static/media/01.d5b36c25.jpg";